import {LoadingActionsTypes} from "../../App/interfaces/loading";
import {Dispatch} from "../../App/reducers/store";
import {CurrencyServices} from "../services/currency";
import {AppActionsTypes} from "../../App/interfaces/app";

const rates = () => {
  return (dispatch: Dispatch): Promise<{ rates: { [code: string]: number } }> => new Promise((resolve, reject) => {
    dispatch({type: LoadingActionsTypes.LOADING, payload: true})
    return CurrencyServices.rates()
      .then(
        rates => {
          dispatch({type: LoadingActionsTypes.LOADING, payload: false})
          dispatch({type: AppActionsTypes.RATES, payload: rates})
          resolve(rates)
        },
        error => {
          dispatch({type: LoadingActionsTypes.LOADING, payload: false})
          reject(error)
        }
      )
  })
}

export const CurrencyActions = {
  rates
}